import { FC, useEffect, useState } from "react";
import "./ModalSubscriptionView.scss";
import { Card, Col, Row } from "react-bootstrap";
import ModalDefault from "../../../ModalDefault/ModalDefault";
import moment from "moment";
import FormatMoney from "../../../../utils/FormatMoney";
import RenderMethodIcon from "../../../../utils/RenderMethodIcon";

interface ModalSubscriptionViewProps {
  show: boolean;
  onClose: () => void;
  subscription: any;
}

const ModalSubscriptionView: FC<ModalSubscriptionViewProps> = ({
  show,
  onClose,
  subscription,
}) => {
  const x = subscription;
  const [selectedPaymentId, setSelectedPaymentId] = useState<number | null>(null);
  const isMonthly = x?.cycle !== "annual";

  useEffect(() => {
    if (x?.payments?.length > 0) {
      setSelectedPaymentId(x.payments[x.payments.length - 1].id);
    } else {
      setSelectedPaymentId(null);
    }
  }, [x]);

  const selectedPayment = x?.payments?.find((p: any) => p.id === selectedPaymentId);

  const allPeriods = isMonthly
    ? (x?.payments || []).flatMap((p: any) => p.periods || [])
    : [];

  const periodsToShow = isMonthly ? allPeriods : (selectedPayment?.periods || []);
  const hasPeriods = periodsToShow.length > 0;


  const renderPaymentStatusBadge = (statusName: string) => {
    const name = statusName?.toLowerCase();
    const className = name === "pago"
      ? "bg-success"
      : name === "pendente"
        ? "bg-warning"
        : "bg-danger";
    return <span className={`badge ${className}`}>{statusName || "-"}</span>;
  };

  return (
    <ModalDefault
      title="Detalhes da Assinatura"
      show={show}
      onClose={onClose}
      sizeModal="xxl"
      showFooter={false}
      scrollable
    >
      {x && (
        <div className="ModalSubscriptionView">
          <Row className="align-items-stretch">
            <Col md={5}>
              {/* Informações do Usuário */}
              <Card className="mb-3 shadow-sm">
                <Card.Header className="pb-0">
                  <h6 className="text-uppercase text-muted fw-bold mb-0">
                    <i className="fas fa-user me-2"></i>Usuário
                  </h6>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={12}>
                      <p className="text-sm mb-1"><strong>Nome:</strong> {x?.user?.partner_code || ""}-{x?.user?.name || ""}</p>
                    </Col>
                    <Col md={12}>
                      <p className="text-sm mb-0"><strong>E-mail:</strong> {x?.user?.email || ""}</p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Informações do Plano */}
              <Card className="mb-3 shadow-sm">
                <Card.Header className="pb-0">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h6 className="text-muted fw-bold mb-0">
                        <i className="fas fa-file-signature me-2"></i><span className="text-uppercase">Plano</span>
                        <p className="text-sm mb-0">{x?.plan?.name || "-"}</p>
                      </h6>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body className="p-0">
                  <table className="table table-flush m-0 w-100 my-2">
                    <thead className="thead-light">
                      <tr>
                        <th className="text-uppercase opacity-7 pb-1" scope="col">Preço Mensal</th>
                        <th className="text-uppercase opacity-7 pb-1" scope="col">Preço Anual</th>
                        <th className="text-uppercase opacity-7 pb-1" scope="col">Período</th>
                        <th className="text-uppercase opacity-7 pb-1" scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-sm">
                        <td className="pt-1">{x?.plan?.price?.monthly ? FormatMoney(x.plan.price.monthly) : "-"}</td>
                        <td className="pt-1">{x?.plan?.price?.annual ? FormatMoney(x.plan.price.annual) : "-"}</td>
                        <td className="pt-1">
                          {x?.start_date ? moment(x.start_date).format("DD/MM/YYYY") : "-"} à{" "}
                          {x?.end_date ? moment(x.end_date).format("DD/MM/YYYY") : "-"}
                        </td>
                        <td className="pt-1">
                          <p className="text-sm text-xs mb-0">
                            <span className={`badge badge-status ${!x?.deleted_at ? "bg-success" : "bg-danger"}`} style={{ position: "relative", top: "-1px" }}>
                              {!x?.deleted_at ? "ATIVO" : "INATIVO"}
                            </span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <Row className="justify-content-center mx-0 my-2 mb-3">
                    <Col md={12}>
                      <p className="text-sm mb-0" style={{ padding: "0 15px" }}>
                        <strong>Descrição:</strong> {x?.plan?.description || "-"}
                      </p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Pagamentos */}
              <Card className="mb-0 shadow-sm">
                <Card.Header className="pb-0">
                  <h6 className="text-uppercase text-muted fw-bold mb-2">
                    <i className="fas fa-credit-card me-2"></i>Pagamentos
                  </h6>
                </Card.Header>
                <Card.Body className="p-0">
                  <div className="table-responsive">
                    <table className="table table-flush m-0 w-100">
                      <thead className="thead-light">
                        <tr>
                          <th className="text-uppercase opacity-7 text-center" scope="col">#</th>
                          <th className="text-uppercase opacity-7" scope="col">Método</th>
                          <th className="text-uppercase opacity-7" scope="col">Valor</th>
                          <th className="text-uppercase opacity-7" scope="col">Cupom</th>
                          <th className="text-uppercase opacity-7 text-center" scope="col">Status</th>
                          <th className="text-uppercase opacity-7 text-center" scope="col">Data Pgto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {x?.payments?.length > 0 ? (
                          x.payments.map((p: any, key: number) => (
                            <tr
                              key={p.id}
                              className={`text-sm payment-row ${!isMonthly && selectedPaymentId === p.id ? "selected" : ""}`}
                              onClick={!isMonthly ? () => setSelectedPaymentId(p.id) : undefined}
                              style={!isMonthly ? { cursor: "pointer" } : {}}
                            >
                              <td className="text-center">{p.id}</td>
                              <td>{RenderMethodIcon(p?.method?.name, 18)}</td>
                              <td><b>{FormatMoney(p.amount_paid)}</b></td>
                              <td>{key == 0 ? (<b>{x?.coupon?.code || "-"}</b>) : '-'}</td>
                              <td className="text-center text-xs">{renderPaymentStatusBadge(p?.status?.name)}</td>
                              <td className="text-center">
                                {p?.payment_date ? moment(p.payment_date).format("DD/MM/YYYY HH:mm") : "-"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={5} className="text-center text-sm">Nenhum pagamento</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={7}>
              {/* Saldo de Mensagens */}
              <Card className="shadow-sm h-100">
                <Card.Header className="pb-0">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div>
                      <h6 className="text-uppercase text-muted fw-bold mb-0">
                        <i className="fas fa-envelope me-2"></i>Saldo de Mensagens
                      </h6>
                    </div>
                    <div>
                      <p className="text-sm mb-0">
                        {x?.start_date ? moment(x.start_date).format("DD/MM/YYYY") : "-"} à{" "}
                        {x?.end_date ? moment(x.end_date).format("DD/MM/YYYY") : "-"}
                      </p>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body className="p-0">
                  {hasPeriods ? (
                    <div className="table-responsive" style={{ minHeight: "65vh", maxHeight: "65vh", overflowY: "auto" }}>
                      <table className="table table-flush m-0 w-100">
                        <thead className="thead-light">
                          <tr>
                            <th className="text-uppercase opacity-7 text-center" scope="col">Período</th>
                            <th className="text-uppercase opacity-7 text-center" scope="col">Início</th>
                            <th className="text-uppercase opacity-7 text-center" scope="col">Fim</th>
                            <th className="text-uppercase opacity-7 text-center" scope="col">Limite</th>
                            <th className="text-uppercase opacity-7 text-center" scope="col">Usadas</th>
                            <th className="text-uppercase opacity-7 text-center" scope="col">Saldo</th>
                          </tr>
                        </thead>
                        <tbody>
                          {periodsToShow.map((period: any, idx: number) => {
                            const now = moment();
                            const isCurrentMonth = now.isSameOrAfter(moment(period.start_date), "day") && now.isSameOrBefore(moment(period.end_date), "day");
                            return (
                              <tr
                                key={`period-${idx}`}
                                className="text-sm"
                                style={isCurrentMonth ? { backgroundColor: "#e8f0fe", fontWeight: "bold" } : {}}
                              >
                                <td className="text-center">{moment(period.period).format("MM/YYYY")}</td>
                                <td className="text-center">
                                  {period.start_date ? moment(period.start_date).format("DD/MM/YYYY") : "-"}
                                </td>
                                <td className="text-center">
                                  {period.end_date ? moment(period.end_date).format("DD/MM/YYYY") : "-"}
                                </td>
                                <td className="text-center">{period.message_limit}</td>
                                <td className="text-center">{period.messages_used}</td>
                                <td className="text-center">
                                  <span className={`badge ${Number(period.messages_balance) > 0 ? "bg-success" : "bg-danger"}`}>
                                    {period.messages_balance}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="text-center opacity-7 my-5">Plano pendente de ativação.</p>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </ModalDefault>
  );
};

export default ModalSubscriptionView;
